import Axios from 'axios'
const API_HOST = process.env.VUE_APP_API_HOST
const API_VERSION = process.env.VUE_APP_API_VERSION
const APP_FILE_HOST = process.env.VUE_APP_FILE_HOST
const ArticleService = {
  /**
   * @description Get article list
   *
   * @returns {object}
   */
  getArticles(params) {
    const getArticlesURL = `${API_HOST}/${API_VERSION}/read/articles`
    return Axios
      .get(getArticlesURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Get article by id
   *
   * @returns {object[]}
   */
  getArticleById(articleId, params) {
    const getArticlesURL = `${API_HOST}/${API_VERSION}/read/articles/${articleId}`
    return Axios
      .get(getArticlesURL, {
        headers: {
          Accept: 'application/json'
        },
        params
      })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  getArticleByRecommend(params) {
  //  const getArticlesURL = `${API_HOST}/${API_VERSION}/read/articles/recommend`
  //  return Axios
  //    .get(getArticlesURL, {
  //      headers: {
  //        Accept: 'application/json'
  //      },
  //      params
  //    })
  //    .then(res => {
  //      if (res && res.data) {
  //        return res.data
  //      }
  //      return { data: {} }
  //    })
  //    .catch(err => {
  //      console.error(err)
  //      return null
  //    })
    const dateTime = Date.now()
    const timestamp = Math.floor(dateTime / 1000)
    const articlesURL = `${APP_FILE_HOST}read/top.json?${timestamp}`
    return Axios.request({
      method: 'GET',
      url: articlesURL,
      headers: {},
      params
    })
      .then(res => {
        if (res && res.data) {
          res.data.data.sort(() => Math.random() - 0.5)
          res.data.data = res.data.data.slice(0, 4)
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description get articles by keyword
   *
   * @returns {object}
   */
  getArticlesByKeyword(params) {
    const articlesURL = `${API_HOST}/${API_VERSION}/read/articles`
    return Axios.request({
      method: 'GET',
      url: articlesURL,
      headers: {},
      params
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description get articles by author id
   *
   * @returns {object}
   */
  getArticlesByAuthorId(authorId, params) {
    const articlesURL = `${API_HOST}/${API_VERSION}/read/authors/${authorId}/articles`
    return Axios.request({
      method: 'GET',
      url: articlesURL,
      headers: {},
      params
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description get tag related articles by tag id
   *
   * @returns {object}
   */
  getArticlesByTagId(tagId, params) {
    const apiURL = `${API_HOST}/${API_VERSION}/read/tags/${tagId}/articles`
    return Axios.request({
      method: 'GET',
      url: apiURL,
      headers: {},
      params
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: [] }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description get articles by tag group id
   *
   * @returns {object}
   */
  getArticlesByTagGroupId(tagGroupId, params) {
    const articlesURL = `${API_HOST}/${API_VERSION}/read/tag_groups/${tagGroupId}/articles`
    return Axios.request({
      method: 'GET',
      url: articlesURL,
      headers: {},
      params
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  getArticlesByPopular(params) {
    const dateTime = Date.now()
    const timestamp = Math.floor(dateTime / 1000)
    const articlesURL = `${APP_FILE_HOST}read/top.json?${timestamp}`
    return Axios.request({
      method: 'GET',
      url: articlesURL,
      headers: {},
      params
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Create a new article
   *
   * @returns {object}
   */
  createArticle(params, formData) {
    const apiURL = `${API_HOST}/${API_VERSION}/read/articles`
    return Axios.request({
      method: 'POST',
      url: apiURL,
      headers: {},
      params,
      data: formData
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Delete a article by ID
   *
   * @returns {object}
   */
  deleteArticle(articleId) {
    const apiURL = `${API_HOST}/${API_VERSION}/read/articles/${articleId}`
    return Axios.request({
      method: 'DELETE',
      url: apiURL,
      headers: {}
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return {}
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Update a article pinned or not
   *
   * @returns {object}
   */
  updateArticlePinned(articleId, pinned) {
    const apiURL = `${API_HOST}/${API_VERSION}/read/articles/${articleId}`
    return Axios.request({
      method: 'PUT',
      url: apiURL,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      transformRequest: [(data, headers) => {
        let transformedData = ''
        for (let key in data) {
          transformedData += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&'
        }
        return transformedData
      }],
      data: {
        pinned
      }
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return {}
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Update a new Article by ID
   *
   * @returns {object}
   */
  updateArticle(params, articleId, formData) {
    const apiURL = `${API_HOST}/${API_VERSION}/read/articles/${articleId}`
    return Axios.request({
      method: 'POST',
      url: apiURL,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: formData,
      params
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Upload a new picture for article content
   *
   * @returns {object}
   */
  uploadImage(params, formData) {
    const apiURL = `${API_HOST}/${API_VERSION}/read/articles/pictures`
    return Axios.request({
      method: 'POST',
      url: apiURL,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: formData,
      params
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return { data: {} }
      })
      .catch(err => {
        console.error(err)
        return null
      })
  },
  /**
   * @description Preview a article by ID
   *
   * @returns {object}
   */
  previewArticle(articleId, params) {
    const apiURL = `${API_HOST}/${API_VERSION}/read/articles/${articleId}/preview`
    return Axios.request({
      method: 'GET',
      url: apiURL,
      headers: {},
      params
    })
      .then(res => {
        if (res && res.data) {
          return res.data
        }
        return {}
      })
      .catch(err => {
        console.error(err)
        return err
      })
  }
}
export default ArticleService
